import React, { useEffect, useState } from 'react';

// @ts-ignore
import Liquid from 'liquid-node';
import { useWidgetUser } from 'requests/resources';

import configService from '@lib/services/configService';

import EmbedCode, { EmbedCodeProps } from './EmbedCode';

// TODO: Move to system template or similar
// https://github.com/lumahealthhq/account-service/pull/702/files#r799709618
const snippet = `<script>
(function(w, d, s, u) {
  w.luma = w.luma || {};
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    r = Math.ceil(new Date() / 3e5) * 3e5;
  j.src = '{{${configService.getSiteWidgets()}}}/widgets/lumabot.min.js?r=' + r;
  f.parentNode.insertBefore(j, f);
  let stateCheck = setInterval(() => {
    if (document.readyState === 'complete') {
      clearInterval(stateCheck);
      w.luma.init(u);
    }
  });
})(window, document, 'script', '{{widgetUser}}');
</script>`;

const engine = new Liquid.Engine();

export interface EmbedCodeWidgetLumaBotProps extends Omit<EmbedCodeProps, 'classes' | 'children'> {}

const EmbedCodeWidgetLumaBot: React.FC<EmbedCodeWidgetLumaBotProps> = ({ ...rest }) => {
  const [valueSanitized, setValueSanitized] = useState(snippet);
  const { data: widgetUser } = useWidgetUser();

  useEffect(() => {
    async function updateValue() {
      const newValue = await engine.parseAndRender(snippet, { ...process.env, widgetUser });
      setValueSanitized(newValue);
    }
    updateValue();
  }, [widgetUser]);

  return <EmbedCode {...rest}>{valueSanitized}</EmbedCode>;
};

export default EmbedCodeWidgetLumaBot;
